require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-integer.js
// module id = 734
// module chunks = 0